import logo from './logo.svg';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import APIManager from './lib/apiManager';
import { useInterval } from './lib/useInterval';
import { Children, useEffect, useState } from 'react';
import { redirect, Route, BrowserRouter as Router, Routes, useNavigate } from 'react-router';
import { doCheckLogin } from './lib/auth';
import Swal from 'sweetalert2';
import Plano from './screens/plano';
import Espacios from './screens/espacios';
import Main from './screens/main';

function App() {
  const [usuario, setUsuario] = useState(null);
  const theme = createTheme({
    palette: {
      primary: {
        main: 'rgba(46, 185, 21, 1)',
        light: 'rgba(84, 245, 66, 1)',
        dark: '#45c015ff',
        contrastText: '#fff',
      }
    }
  });

  const doLogout = () => {
    APIManager.sendRequest('post', 'usuario', 'logout', {}, (response) => {
      if (response.success) {
        setUsuario(null);
      }
    });
  }

  const doLogin = (userData) => {
    APIManager.sendRequest('post', 'usuario', 'login', userData, (response) => {
      if (response.success) {
        setUsuario(response.data.usuario);
      } else {
        Swal.fire({
          // title: 'Login incorrecto',
          html: `${response.errors[0].message}`,
          icon: 'error',
          confirmButtonColor: '#08996B',
          confirmButtonText: 'ACEPTAR',
          allowOutsideClick: false,
        })
      }
    });
  }

  useEffect(() => {
    if (!usuario) {
      doCheckLogin(null, setUsuario);
    }
  }, [usuario])

  useInterval(() => {
    doCheckLogin(null, setUsuario);
  }, 60000)

  // const doCheckLogin = (userData) => {
  //   APIManager.sendRequest('post', 'usuario', 'me', {}, (response) => {
  //     if (response.success) {
  //       setUsuario(response.data.usuario);
  //     } else {
  //       setUsuario(null);
  //     }
  //   });
  // }

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Main usuario={usuario}/>
      </Router>
    </ThemeProvider>
  );
}

export default App;
